import { ChatProgressInfo } from '@agent/agent-interface/contact-view/chat/model/chat-progress-info';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'chat-attachment-preview',
  templateUrl: 'chat-attachment-preview.component.html',
  styleUrls: ['./chat-attachment-preview.component.scss'],
})
export class ChatAttachmentPreviewComponent {
  @Input()
  public attachments: ChatProgressInfo[];

  @Output()
  public onCancel: EventEmitter<any> = new EventEmitter();

  @Output()
  public onUpload: EventEmitter<any> = new EventEmitter();

  $onInit() {}

  cancel(attachment) {
    if (this.onCancel) {
      this.onCancel.emit(attachment);
    }
  }

  upload(attachment) {
    if (this.onUpload) {
      this.onUpload.emit(attachment);
    }
  }
}
